import React from 'react'

type Props = {
    message : string
    onSkip  : any
}

export default function ErrorMessage({ message, onSkip }: Props) {
    return (
        <div style={{
            display         : 'flex',
            flexDirection   : 'column',
            alignItems      : 'center',
            justifyContent  : 'center',
            width           : '100%',
            height          : '100%',
            minHeight       : '220px',
            gap             : '20px',
        }}>
            <div style={{
                width           : '52px',
                height          : '52px',
                borderRadius    : '50%',
                background      : '#fee2e2',
                display         : 'flex',
                alignItems      : 'center',
                justifyContent  : 'center',
                fontSize        : '1.6rem',
                color           : '#dc2626',
                fontWeight      : 700,
                lineHeight      : 1,
            }}>
                !
            </div>

            <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '1.05rem', fontWeight: 600, color: '#1f1f1f', marginBottom: '6px' }}>
                    Something went wrong
                </div>
                <div style={{ fontSize: '0.9rem', color: '#888' }}>
                    {message}
                </div>
            </div>

            <button
                onClick={onSkip}
                style={{
                    padding         : '8px 28px',
                    fontSize        : '0.9rem',
                    fontWeight      : 500,
                    color           : '#555',
                    background      : 'transparent',
                    border          : '1.5px solid #ccc',
                    borderRadius    : '6px',
                    cursor          : 'pointer',
                    transition      : 'border-color 0.15s, color 0.15s',
                }}
                onMouseEnter={e => {
                    (e.currentTarget as HTMLButtonElement).style.borderColor = '#999'
                    ;(e.currentTarget as HTMLButtonElement).style.color = '#333'
                }}
                onMouseLeave={e => {
                    (e.currentTarget as HTMLButtonElement).style.borderColor = '#ccc'
                    ;(e.currentTarget as HTMLButtonElement).style.color = '#555'
                }}
            >
                Skip
            </button>
        </div>
    )
}
